export default "__VITE_ASSET__BC4vBZO$__"